"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BGTypographyVariants = exports.TypographyVariants = exports.Effects = exports.Spacing = exports.InputVariants = exports.ButtonVariants = exports.NeutralColors = exports.SystemColors = exports.createUseStyles = exports.useTheme = exports.makeStyles = exports.withStyles = void 0;
var react_jss_1 = require("react-jss");
var styles_1 = require("@material-ui/core/styles");
Object.defineProperty(exports, "withStyles", { enumerable: true, get: function () { return styles_1.withStyles; } });
Object.defineProperty(exports, "makeStyles", { enumerable: true, get: function () { return styles_1.makeStyles; } });
Object.defineProperty(exports, "useTheme", { enumerable: true, get: function () { return styles_1.useTheme; } });
function createUseStyles(styles) {
    return (0, react_jss_1.createUseStyles)(styles);
}
exports.createUseStyles = createUseStyles;
var SystemColors;
(function (SystemColors) {
    SystemColors["BgMain"] = "BgMain";
    SystemColors["TextInvert"] = "TextInvert";
    SystemColors["BgMinor"] = "BgMinor";
    SystemColors["Divider"] = "Divider";
    SystemColors["ButtonMinor"] = "ButtonMinor";
    SystemColors["ControlMinor"] = "ControlMinor";
    SystemColors["Line"] = "Line";
    SystemColors["IconMinor"] = "IconMinor";
    SystemColors["TextMinor"] = "TextMinor";
    SystemColors["IconMain"] = "IconMain";
    SystemColors["TextMain"] = "TextMain";
    SystemColors["BgInvert"] = "BgInvert";
    SystemColors["SubtleAccent"] = "SubtleAccent";
    SystemColors["SelectedListItem"] = "SelectedListItem";
    SystemColors["ButtonMain"] = "ButtonMain";
    SystemColors["ControlMain"] = "ControlMain";
    SystemColors["Link"] = "Link";
    SystemColors["BgSuccess"] = "BgSuccess";
    SystemColors["TextSuccess"] = "TextSuccess";
    SystemColors["BgAttention"] = "BgAttention";
    SystemColors["TextAttention"] = "TextAttention";
})(SystemColors = exports.SystemColors || (exports.SystemColors = {}));
var NeutralColors;
(function (NeutralColors) {
    NeutralColors["Text"] = "Text";
    NeutralColors["BgGradient"] = "BgGradient";
    NeutralColors["BgOpaque"] = "BgOpaque";
    NeutralColors["BgTransparent"] = "BgTransparent";
})(NeutralColors = exports.NeutralColors || (exports.NeutralColors = {}));
var ButtonVariants;
(function (ButtonVariants) {
    ButtonVariants["Main"] = "Main";
    ButtonVariants["SubtleAccent"] = "SubtleAccent";
    ButtonVariants["Default"] = "Default";
    ButtonVariants["Outline"] = "Outline";
    ButtonVariants["Float"] = "Float";
    ButtonVariants["Plain"] = "Plain";
})(ButtonVariants = exports.ButtonVariants || (exports.ButtonVariants = {}));
var InputVariants;
(function (InputVariants) {
    InputVariants["Frame"] = "Frame";
    InputVariants["Line"] = "Line";
    InputVariants["Float"] = "Float";
})(InputVariants = exports.InputVariants || (exports.InputVariants = {}));
var Spacing;
(function (Spacing) {
    Spacing[Spacing["None"] = 0] = "None";
    Spacing[Spacing["XS"] = 4] = "XS";
    Spacing[Spacing["S"] = 8] = "S";
    Spacing[Spacing["M"] = 16] = "M";
    Spacing[Spacing["L"] = 24] = "L";
    Spacing[Spacing["XL"] = 32] = "XL";
})(Spacing = exports.Spacing || (exports.Spacing = {}));
var Effects;
(function (Effects) {
    Effects["ShadowBottom"] = "ShadowBottom";
    Effects["TooltipShadow"] = "TooltipShadow";
    Effects["ButtonLoading"] = "ButtonLoading";
    Effects["Hovered"] = "Hovered";
    Effects["Pressed"] = "Pressed";
})(Effects = exports.Effects || (exports.Effects = {}));
/**
 * @deprecated
 */
var TypographyVariants;
(function (TypographyVariants) {
    TypographyVariants["Header"] = "Header";
    TypographyVariants["LargeTitle"] = "LargeTitle";
    TypographyVariants["Number"] = "Number";
    TypographyVariants["Title"] = "Title";
    TypographyVariants["Headline1"] = "Headline1";
    TypographyVariants["Headline2"] = "Headline2";
    TypographyVariants["Body"] = "Body";
    TypographyVariants["Subhead"] = "Subhead";
    TypographyVariants["Caption"] = "Caption";
})(TypographyVariants = exports.TypographyVariants || (exports.TypographyVariants = {}));
var BGTypographyVariants;
(function (BGTypographyVariants) {
    BGTypographyVariants["Header"] = "B&G/Header";
    BGTypographyVariants["Title1"] = "B&G/Title1";
    BGTypographyVariants["Title2"] = "B&G/Title2";
    BGTypographyVariants["Title3"] = "B&G/Title3";
    BGTypographyVariants["Title4"] = "B&G/Title4";
    BGTypographyVariants["Body1"] = "B&G/Body1";
    BGTypographyVariants["Body2"] = "B&G/Body2";
    BGTypographyVariants["Caption1"] = "B&G/Caption1";
    BGTypographyVariants["Caption2"] = "B&G/Caption2";
})(BGTypographyVariants = exports.BGTypographyVariants || (exports.BGTypographyVariants = {}));
